// Los modales del widget: lo que en la home hace SweetAlert2.
//
// El buscador usa tres, y ninguno necesita una librería:
//   - el aviso de "en paquetes con hotel no se puede seleccionar eso", con un botón;
//   - la pregunta "¿quieres añadir hotel al viaje?", con Sí y No — y ojo, que la respuesta
//     decide la rama de salida entera (Compra/3833 con hotel, o CompraDestino con Viaje+);
//   - el modal de pasajeros, que no es un modal de texto sino una plantilla del markup.
//
// Todos se montan en el contenedor de overlays del widget, al final de <body>, y no en medio
// del widget: un z-index no cruza el contexto de apilamiento que la landing haya creado con un
// `transform` o un `filter` en cualquier antepasado.
//
// El foco se atrapa dentro mientras está abierto y vuelve a donde estaba al cerrar, que es lo
// mínimo para que esto se pueda usar con teclado.

function crearCaja (buscador, clase) {
  const fondo = document.createElement('div')
  fondo.className = 'rvb-w rvb-swal-buscador-renfe-fondo'
  const caja = document.createElement('div')
  caja.className = 'rvb-swal-buscador-renfe ' + clase
  caja.setAttribute('role', 'dialog')
  caja.setAttribute('aria-modal', 'true')
  fondo.appendChild(caja)
  buscador.overlays.appendChild(fondo)
  return { fondo, caja }
}

function atraparFoco (caja, alEscapar) {
  const anterior = document.activeElement
  const enfocables = () => [...caja.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
    .filter((e) => !e.disabled && e.offsetParent !== null)
  const primero = enfocables()[0]
  if (primero) primero.focus()

  const alPulsar = (e) => {
    if (e.key === 'Escape') { e.preventDefault(); alEscapar(); return }
    if (e.key !== 'Tab') return
    const lista = enfocables()
    if (!lista.length) return
    const i = lista.indexOf(document.activeElement)
    if (e.shiftKey && (i <= 0)) { e.preventDefault(); lista[lista.length - 1].focus() }
    else if (!e.shiftKey && i === lista.length - 1) { e.preventDefault(); lista[0].focus() }
  }
  document.addEventListener('keydown', alPulsar)
  return () => {
    document.removeEventListener('keydown', alPulsar)
    if (anterior && anterior.focus) anterior.focus()
  }
}

/**
 * Un aviso con un solo botón.
 * @returns {Promise<void>}  se resuelve al cerrarlo, como hacía el .then() de swal
 */
export function aviso (buscador, { titulo, texto, confirmar }) {
  return new Promise((resolver) => {
    const { fondo, caja } = crearCaja(buscador, 'rvb-swal-aviso')
    caja.innerHTML = '<h2 class="rvb-swal-titulo"></h2><div class="rvb-swal-texto"></div>'
      + '<div class="rvb-botones"><button type="button" class="rvb-btn-confirm"></button></div>'
    caja.querySelector('.rvb-swal-titulo').textContent = titulo || ''
    caja.querySelector('.rvb-swal-texto').textContent = texto || ''
    const boton = caja.querySelector('.rvb-btn-confirm')
    boton.textContent = confirmar || 'Vale'
    caja.setAttribute('aria-label', titulo || '')

    const soltar = atraparFoco(caja, cerrar)
    function cerrar () { soltar(); fondo.remove(); resolver() }
    boton.addEventListener('click', cerrar)
    fondo.addEventListener('mousedown', (e) => { if (e.target === fondo) cerrar() })
  })
}

/**
 * Una pregunta de sí o no.
 * @returns {Promise<boolean>}
 */
export function preguntar (buscador, { titulo, texto, si, no }) {
  return new Promise((resolver) => {
    const { fondo, caja } = crearCaja(buscador, 'rvb-swal-hotel')
    caja.innerHTML = '<h2 class="rvb-swal-titulo"></h2><div class="rvb-swal-texto"></div>'
      + '<div class="rvb-botones">'
      + '<button type="button" class="rvb-btn-confirm"></button>'
      + '<button type="button" class="rvb-btn-deny"></button>'
      + '</div>'
    caja.querySelector('.rvb-swal-titulo').textContent = titulo || ''
    caja.querySelector('.rvb-swal-texto').textContent = texto || ''
    const sim = caja.querySelector('.rvb-btn-confirm')
    const nop = caja.querySelector('.rvb-btn-deny')
    sim.textContent = si || 'Sí'
    nop.textContent = no || 'No'
    caja.setAttribute('aria-label', titulo || '')

    const soltar = atraparFoco(caja, () => cerrar(false))
    function cerrar (respuesta) { soltar(); fondo.remove(); resolver(respuesta) }
    sim.addEventListener('click', () => cerrar(true))
    nop.addEventListener('click', () => cerrar(false))
    fondo.addEventListener('mousedown', (e) => { if (e.target === fondo) cerrar(false) })
  })
}

/**
 * Un modal con contenido del markup (el de pasajeros y el del calendario de salida de hotel).
 * Devuelve la caja para que quien lo abre cablee lo de dentro, y una forma de cerrarlo.
 */
export function modalConPlantilla (buscador, nombrePlantilla, clase) {
  const contenido = buscador.dom.plantilla(nombrePlantilla)
  if (!contenido) return null
  const { fondo, caja } = crearCaja(buscador, clase || '')
  caja.appendChild(contenido)
  let soltar = null
  const cerrar = () => { if (soltar) soltar(); fondo.remove() }
  soltar = atraparFoco(caja, cerrar)
  fondo.addEventListener('mousedown', (e) => { if (e.target === fondo) cerrar() })
  return { fondo, caja, contenido, cerrar }
}
